/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { Pagi } from "src/libs/useful"
import { setAutoHeightByQuery, setMaxHeightByQuery } from "src/libs/utilities"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ALIGN, ICard, ImageContent, IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { IState, useMainStore } from "src/settings/zustand"
import "../../../../assets/css/cards.scss"
import { ICardsProps } from "../Cards"
import Card from "./Card"
import { ImagePrimitive } from "../../primitive"
import DataContentEditor from "../../landing-edit/editors/data-content-editor"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
const CardsList = ({data, ...props}: ICardsProps): JSX.Element => {
    const thumbRef              = useRef<HTMLDivElement>(null)
    const sizes                 = useLandingSize()    
    const currentDimensionEdit  = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    const sizeWidth             = Math.min( sizes.width, currentDimensionEdit )

    const theme                 = useMainStore( ( state: IState ) => state.theme )
    const numberposts: number   = useMainStore( ( state: IState ) => state.pageCount )
    const composition           = useComposition( props.section )
    const offset                = useSyncState<number>( 0 ) 
    const [marginLeft]          = useState<string>(!![ ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)    || !data.horizontal_align ? "auto" : "0")
    const [marginRight]         = useState<string>(!![ ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginTop]           = useState<string>(!![ ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align)      || !data.vertical_align   ? "auto" : "0")
    const [marginBottom]        = useState<string>(!![ ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align)    || !data.vertical_align   ? "auto" : "0")
    const [width]               = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]            = useState<string>(getCssDemention( data.height, "fit-content" ))
    const [thumbnailSize, setThumbnailSize] = useState<IScreenPosition>({ width: "100%", height: "100%" })
    const alignFields = () => {
        if(data.vertical_align === ALIGN.START) {
            return
        }
        if(!data.vertical_align || data.vertical_align === ALIGN.FULL ) {
            if(sizeWidth > WINDOW_WIDTH.TABLET) {
                data.card_fields.forEach((field, i) => {
                    setMaxHeightByQuery( `.landing-cards-${data.id} [data-card-field-id="${i}"]` );
                    setMaxHeightByQuery( `.landing-cards-${data.id} [data-card-field-id="${i}"] .speech-bubble-content`);
                })
            }
            else {
                // data.card_fields.forEach((field, i) => {
                //     setAutoHeightByQuery( `.landing-cards-${data.id} [data-card-field-id="${i}"]` );
                //     setAutoHeightByQuery( `.landing-cards-${data.id} [data-card-field-id="${i}"] .speech-bubble-content`);
                // })
            }
        }
    }
    useEffect(() => {
        addCSSClass(
            `landing-cards-${data.id}`,
            `.landing-cards-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            .cards-thumbnail-${data.id} {

            }
            `
        )
        if(thumbRef.current) {
            const thumb = thumbRef.current
            const h = document.querySelector( `.landing-cards-${data.id}` )?.clientHeight || thumb.clientHeight
            
            // console.log( document.querySelector( `.landing-cards-${data.id}` ), document.querySelector( `.landing-cards-${data.id}` )?.clientHeight )
            
            setThumbnailSize({
                width:  thumb.clientWidth,
                height: h,
                aspect: thumb.clientWidth / h
            })
        }
        alignFields()
        return () => {
            removeCSSClass(`landing-card-${data.id}`)
        }
    },[])
       
    useEffect(()=> {
        alignFields()
    }, [ composition, data, theme ]) 

    const onPagi = ( n: number ): void => { 
        const newOffset: number = n * numberposts
        offset.set( newOffset )  
        setTimeout(() => alignFields(), 100)
    } 

    return <div className={`pe-cards-container landing-content-container`}  data-type={data.type} data-content-id={data.id}>
        <div className="mx-5">
            {
                Array.isArray( data.cards ) && data.cards.length > numberposts && < Pagi
                    all={ Math.ceil(data.cards.length / numberposts) - 1 }
                    current={ offset.get() / numberposts}
                    onChoose={ onPagi }  
                    marginPagesDisplayed={ 4 } 
                />
            }
        </div> 
        <div 
            className="landing-cards-container" 
            style={{ 
                gridTemplateColumns: data.isRightThumbnail 
                    ? 
                    `${100 - 100* (data.proportia || .5)}% ${100 * (data.proportia || .5) }%`
                    :
                    `${100* (data.proportia || .5)}% ${100 - 100 * (data.proportia || .5) }%`
            }}
            
        >    
            {
                data.thumbnail && 
                    <div className={`cards-thumbnail cards-thumbnail-${ data.id } ${ data.isRightThumbnail ? "is-right" : ""}`} ref={thumbRef}>
                        {
                            thumbnailSize.width !== "100%" && 
                                <>
                                    <ImagePrimitive 
                                        section={props.section}
                                        field="thumbnail"
                                        primitive={{
                                            ...data.thumbnail, 
                                            style: {},
                                            id: `thumbnail-${data.id}`,
                                            position: { ...thumbnailSize },
                                            data: { ...(data.thumbnail ? data.thumbnail.data : {}), src_type: "div" } 
                                        } as ImageContent }
                                    />
                                </>
                        } 
                    </div>
            }
            <div className={`landing-cards landing-cards-${data.id} ${ data.className || "" } `} >  
                {
                    Array.isArray(data.cards) && 
                    data.cards
                        .filter( (card: ICard, i: number) => i >= offset.get() && i < offset.get() + numberposts )
                        .map((card: ICard, i: number) =>  { 
                            return <Card
                                key={ card.id }
                                data={ { ...card, i:i } }
                                contentData={ data }
                                section={ props.section }
                            />
                        })
                }
            </div>
        </div>
        <div className="mx-5">
            {
                Array.isArray(data.cards) && data.cards.length > numberposts && <Pagi
                    all={Math.ceil(data.cards.length / numberposts) - 1}
                    current={ offset.get() / numberposts}
                    onChoose={ onPagi }  
                    marginPagesDisplayed={ 4 } 
                />
            }
        </div>
        <DataContentEditor data={data}  section={props.section}  />
    </div>
}
export default CardsList


